// src/components/modals/AddUserModal.jsx
import React, { useState } from 'react';
import axios from 'axios';
import { X, User, Building, Save, LoaderCircle, Shield, Mail } from 'lucide-react';

export default function AddUserModal({ currentUser, onClose, onSave }) {
  const [formData, setFormData] = useState({
    nome: '',
    sobrenome: '',
    email: '',
    hub: '',
    role: 'operator',
    status: 'ativo'
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  if (!currentUser) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // --- NOVAS VALIDAÇÕES ---
    const emailDomain = formData.email.split('@')[1];
    const allowedDomains = ['shopee.com', 'shopeemobile-external.com'];

    if (!formData.nome.trim() || !formData.email.trim() || !formData.sobrenome.trim() || !formData.hub.trim()) {
      setError('Todos os campos são obrigatórios.');
      return;
    }
    
    if (!allowedDomains.includes(emailDomain)) {
      setError('O e-mail deve pertencer aos domínios @shopee.com ou @shopeemobile-external.com.');
      return;
    }
    // --- FIM DAS VALIDAÇÕES ---

    setIsLoading(true);
    try {
      const token = sessionStorage.getItem('app_token');
      await axios.post('/api/users', formData, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      onSave();
    } catch (err) {
      console.error("Erro ao criar usuário:", err);
      setError(err.response?.data?.detail || 'Não foi possível criar o usuário.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-800">Cadastrar Novo Usuário</h2>
          <button onClick={onClose} disabled={isLoading} className="p-1 rounded-full bg-gray-100 hover:bg-gray-200 disabled:opacity-50">
            <X size={20} className="text-gray-600" />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div className="relative">
              <Mail size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email do usuário" disabled={isLoading} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#EE4D2D]" />
            </div>
            <div className="relative">
              <User size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input type="text" name="nome" value={formData.nome} onChange={handleChange} placeholder="Nome" disabled={isLoading} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#EE4D2D]" />
            </div>
            <div className="relative">
              <User size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input type="text" name="sobrenome" value={formData.sobrenome} onChange={handleChange} placeholder="Sobrenome" disabled={isLoading} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#EE4D2D]" />
            </div>
            <div className="relative">
              <Building size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input type="text" name="hub" value={formData.hub} onChange={handleChange} placeholder="Hub" disabled={isLoading} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#EE4D2D]" />
            </div>
            <div className="relative">
              <Shield size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <select name="role" value={formData.role} onChange={handleChange} disabled={isLoading} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#EE4D2D] bg-white appearance-none">
                {currentUser.role === 'admin-dev' && <option value="admin-dev">Admin (Master)</option>}
                <option value="admin-op">Admin (Operações)</option>
                <option value="operator">Operador</option>
              </select>
            </div>
          </div>
          
          {error && <p className="text-red-500 text-sm mt-4">{error}</p>}

          <div className="mt-6 flex items-center justify-end space-x-3">
            <button type="button" onClick={onClose} disabled={isLoading} className="px-6 py-2 rounded-lg text-gray-700 bg-gray-100 hover:bg-gray-200">
              Cancelar
            </button>
            <button type="submit" disabled={isLoading} className="px-6 py-2 flex items-center justify-center bg-[#EE4D2D] text-white font-bold rounded-lg hover:bg-[#D03F2A] disabled:bg-red-300">
              {isLoading ? <LoaderCircle size={20} className="animate-spin" /> : <><Save size={18} className="mr-2" /> Cadastrar</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}